
import GalleryBanner from "../components/Gallery/GalleryBanner";
import GalleryTabs from "../components/Gallery/GalleryTabs";

const Gallery = () => {

  return (
    <>
      <GalleryBanner />
      <GalleryTabs />
    </>
  );
};

export default Gallery;
